import { useState } from "react";
import { SecurityHeader } from "./security/SecurityHeader";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { AccessControlSettings } from "./AccessControlSettings";
import { ButtonVisibilitySettings } from "./security/ButtonVisibilitySettings";

export const SecuritySettings = () => {
  return (
    <div className="space-y-6">
      <SecurityHeader />
      <Tabs defaultValue="access-codes" className="space-y-4">
        <TabsList>
          <TabsTrigger value="access-codes">Codes d'accès</TabsTrigger>
          <TabsTrigger value="button-visibility">Visibilité des boutons</TabsTrigger>
        </TabsList>

        <TabsContent value="access-codes" className="space-y-4">
          <AccessControlSettings />
        </TabsContent>

        <TabsContent value="button-visibility" className="space-y-4">
          <ButtonVisibilitySettings />
        </TabsContent>
      </Tabs>
    </div>
  );
};